
namespace GeniuzPOS.ReportMasterData {

    @Serenity.Decorators.registerClass()
    export class Report_1101Grid extends Serenity.EntityGrid<Report_1101Row, any> {
        myGridDropdownButton: Common.Helpers.GridDropdownButton;
        protected getColumnsKey() { return Report_1101Columns.columnsKey; }
        protected getDialogType() { return Report_1101Dialog; }
        protected getIdProperty() { return Report_1101Row.idProperty; }
        protected getInsertPermission() { return Report_1101Row.insertPermission; }
        protected getLocalTextPrefix() { return Report_1101Row.localTextPrefix; }
        protected getService() { return Report_1101Service.baseUrl; }

        constructor(container: JQuery) {
            super(container);

            let combineButtons: GeniuzPOS.Common.Helpers.GridDropdownButtonItem[] = [
                {
                    key: "SellUnitPrice1",
                    title: "1",
                    isDefault: true,
                    onClick: () => this.showOnlyPriceColumn('SellUnitPrice1')
                },
                {
                    key: "SellUnitPrice2",
                    title: "2",
                    onClick: () => this.showOnlyPriceColumn('SellUnitPrice2')
                },
                {
                    key: "SellUnitPrice3",
                    title: "3",
                    onClick: () => this.showOnlyPriceColumn('SellUnitPrice3')
                },
                {
                    key: "SellUnitPrice4",
                    title: "4",
                    onClick: () => this.showOnlyPriceColumn('SellUnitPrice4')
                },
                {
                    key: "SellUnitPrice5",
                    title: "5",
                    onClick: () => this.showOnlyPriceColumn('SellUnitPrice5')
                },
                {
                    key: "SellUnitPrice6",
                    title: "6",
                    onClick: () => this.showOnlyPriceColumn('SellUnitPrice6')
                },
            ];

            this.myGridDropdownButton = new GeniuzPOS.Common.Helpers.GridDropdownButton(this.toolbar.element.find(".buttons-outer"), combineButtons, {
                title: "ราคาขาย",
                cssClass: "price-selection-button",
            })

            this.showOnlyPriceColumn('SellUnitPrice1')
        }

        private getFilterDescriptions(grid: Serenity.DataGrid<any, any>, gridColumns: Slick.Column[], options: GeniuzPOS.Common.Helpers.Report1102PdfOptions): any {
            let request = Q.deepClone(grid.view.params) as Serenity.ListRequest;
            let columns = Object.keys(options.columnStyles)

            let descriptions: string[] = [];

            var el = grid.element.find('.price-selection-button');
            var selectedKey = $(el).attr('data-selected-key');
            if (selectedKey) {
                var chk = selectedKey.substring(0, selectedKey.length - 1);
                gridColumns = gridColumns.filter(c => !c.field.startsWith(chk) || c.field === selectedKey)
                let n = columns.find(n => {
                    return options.columnStyles[n]['field'].startsWith(chk)
                });
                descriptions.push(`ราคาขายที่ : ${options.columnStyles[n]['title']}-${selectedKey.replace(chk, '')}`)
            }

            if (request?.EqualityFilter) {
                let quickFilters = this.getQuickFilters();
                console.log(quickFilters)
                let filters = Object.keys(request.EqualityFilter);
                for (let filterCol of filters) {
                    let quickFilter = Q.first(quickFilters, x => x.field === filterCol);
                    let filterValue = request.EqualityFilter[filterCol];
                    if (filterValue) {
                        if (quickFilter.options.lookupKey) {
                            let lookup = Q.getLookup(quickFilter.options.lookupKey);
                            filterValue = lookup.itemById[filterValue][lookup.textField];
                        } else if (quickFilter.options.enumKey) {
                            let enumKey = quickFilter.options.enumKey;
                            let enumValue = Q.toId(filterValue);
                            filterValue = Serenity.EnumFormatter.format(Serenity.EnumTypeRegistry.get(enumKey), enumValue);
                        }
                    } else {
                        filterValue = "ไม่ระบุ";
                    }

                    let n = columns.find(n => {
                        return options.columnStyles[n]['field'] === filterCol
                    });
                    if (n) {
                        descriptions.push(`${options.columnStyles[n]['title']} = ${filterValue}`)
                    }
                }
            }

            return [descriptions, gridColumns];
        }


        // protected createQuickSearchInput() {
        // }

        protected getColumns() {
            var columns = super.getColumns();

            return columns;
        }

        protected createSlickGrid() {
            var grid = super.createSlickGrid();

            // need to register this plugin for grouping or you'll have errors
            grid.registerPlugin(new Slick.Data.GroupItemMetadataProvider());

            return grid;
        }
        protected createToolbarExtensions() {
            super.createToolbarExtensions();
    
            this.slickGrid.registerPlugin(new Slick.Data.GroupItemMetadataProvider());
                
            var groupingMixin = new Serenity.DraggableGroupingMixin({
                grid: this
            });
    
            // setting ShipCountry, ShipCity columns as initially grouped for this sample
            // you could add [GroupOrder(1)] to ShipCountry, and [GroupOrder(2)] to ShipCity
            // in OrderColumns.cs instead (recommended way)
            groupingMixin.plugin.setDroppedGroups(["  "]);
        }
        
        protected getSlickOptions() {
            var opt = super.getSlickOptions();
            opt.showFooterRow = true;
            opt.groupingPanel = true;
            return opt;
        }

        // protected usePager() {
        //     return false;
        // }

        protected getButtons() {
            var buttons = super.getButtons();

            // remove first button (Add button)
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);
            

            // Add buttons import excel, pdf
            buttons.push(Common.Helpers.ExcelExportHelper.createToolButton({
                grid: this,
                service: Report_1101Service.baseUrl + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));


            let reportTitle = 'รายงานทะเบียนสินค้า(Product master list)'

            // Max page width = 277
            let columnStyles: { [dataKey: string]: GeniuzPOS.Common.Helpers.AutoTableStyles } = {
                0: { field: "PluCode", title: "รหัสขาย (PLU)", cellWidth: 20 },
                1: { field: "SkuCode", title: "รหัสสต๊อก (SKU)", cellWidth: 20 },
                2: { field: "PluDesc", title: "ชื่อสินค้า", cellWidth: 45 ,overflow:'linebreak'},
                3: { field: "PurUnitPrice", title: "ราคาซื้อ", cellWidth: 10 , halign: 'right'},
                4: { field: "PurUnit", title: "ซื้อ", cellWidth: 10 ,halign: 'center'},
                5: { field: "PurUnitRatio", title: "Ratio", cellWidth: 10 ,halign: 'center'},
                6: { field: "StkUnit", title: "สต๊อก", cellWidth: 10 ,halign: 'center'},
                7: { field: "SellUnitRatio", title: "Ratio", cellWidth: 10 ,halign: 'center'},
                8: { field: "SellUnit", title: "ขาย", cellWidth: 10 ,halign: 'center'},
                9: { field: "SellUnitPrice1", title: "ราคาขาย", cellWidth: 15, halign: 'right'},
                10: { field: "SellUnitPrice2", title: "ราคาขาย", cellWidth: 15 , halign: 'right'},
                11: { field: "SellUnitPrice3", title: "ราคาขาย", cellWidth: 15 , halign: 'right'},
                12: { field: "SellUnitPrice4", title: "ราคาขาย", cellWidth: 15 , halign: 'right'},
                13: { field: "SellUnitPrice5", title: "ราคาขาย", cellWidth: 15 , halign: 'right'},
                14: { field: "SellUnitPrice6", title: "ราคาขาย", cellWidth: 15 , halign: 'right'},
                15: { field: "CatName", title: "หมวดสินค้า", cellWidth: 25, isHidden: true },
                16: { field: "SubCat1Name", title: "หมวดสินค้า-2", cellWidth: 25, isHidden: true },
                17: { field: "SubCat2Name", title: "หมวดสินค้า-3", cellWidth: 25, isHidden: true },
                18: { field: "BrandName", title: "หมวดสินค้า-3", cellWidth: 25, isHidden: true},
                19: { field: "MinStockQty", title: "Min", cellWidth: 15,halign: 'center' },
                20: { field: "MaxStockQty", title: "Max", cellWidth: 15,halign: 'center' },
                21: { field: "PurLeadTime", title: "L.T.(วัน)", cellWidth: 15,halign: 'center'},
                // 21: { field: "VatType", title: "V?", cellWidth: 15 },
                22: { field: "VatCode", title: "V.Code", cellWidth: 20 ,halign: 'center'},
                // 19: { field: "MatTypeName", title: "วัสดุที่ใช้ผลิต", cellWidth: 15, isHidden: true},
            }

            // buttons.push(GeniuzPOS.Common.Helpers.PdfExportHelper.createToolButton({
            //     grid: this,
            //     onViewSubmit: () => this.onViewSubmit(),
            //     reportTitle: reportTitle,
            //     separator: true,
            //     pageNumbers: true,
            //     onCreateFilterDescriptions: (grid: Serenity.DataGrid<any, any>, gridColumns: Slick.Column[], options: GeniuzPOS.Common.Helpers.Report1102PdfOptions) => this.getFilterDescriptions(grid, gridColumns, options),
            //     columnStyles: columnStyles,
            //     groupHeader: {
            //         0: { title: 'หน่วย', startX: 100, width: 60 }
            //     },
            //     hideGroupColumn: false,
            //     theme: 'plain',
            //     showTableHead: 'everyPage',
            //     isCustomHeader: true,

            //     //reportTitle: "This is report title",
            //     titleTop: 7,
            //     titleFontSize: 12,
            //     fileName: "ThisIsTheFileName",
            //     //pageNumbers: true,
            //     columnTitles: {
            //         'OriginalColumn': 'OCol.',
            //     },
            //     tableOptions: {
            //         columnStyles: {
            //             OriginalColumn: {
            //                // columnWidth: 25,
            //                 halign: 'right'
            //             }
            //         }
            //     }
            // }));

            // buttons.push(GeniuzPOS.Common.Helpers.PdfExportHelper.createToolButton({
            //     grid: this,
            //     onViewSubmit: () => this.onViewSubmit(),
            //     reportTitle: reportTitle,
            //     //separator: true,
            //     pageNumbers: true,
            //     onCreateFilterDescriptions: (grid: Serenity.DataGrid<any, any>, gridColumns: Slick.Column[], options: GeniuzPOS.Common.Helpers.Report1102PdfOptions) => this.getFilterDescriptions(grid, gridColumns, options),
            //     autoPrint: true,
            //     output: "dataurlnewwindow",
            //     columnStyles: columnStyles,
            //     groupHeader: {
            //         0: { title: 'หน่วย', startX: 100, width: 50 }
            //     },
            //     hideGroupColumn: false,
            //     theme: 'plain',

            //     showTableHead: 'everyPage',
            //     isCustomHeader: true,

            //     //reportTitle: "This is report title",
            //     titleTop: 7,
            //     titleFontSize: 12,
            //     fileName: "ThisIsTheFileName",
            //     //pageNumbers: true,
            //     columnTitles: {
            //         'OriginalColumn': 'OCol.',
            //     },
            //     tableOptions: {
            //         columnStyles: {
            //             OriginalColumn: {
            //                // columnWidth: 25,
            //                 halign: 'right'
            //             }
            //         }
            //     }
            // }));
            buttons.push(
                {
                    title: Q.text("Close"), // *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    onClick: () => {
                        window.location.href = '/';
                        return false;
                    },
                }
            );

            // //Buttons Group By Category
            // buttons.push({
            //     title: 'Group By หมวดสินค้า',
            //     cssClass: 'expand-all-button',
            //     separator: true,
            //     onClick: () => this.view.setGrouping(
            //         [{
            //             formatter: x => 'หมวดสินค้า: ' + x.value + ' (' + x.count + ' items)',
            //             getter: 'CatName',
            //         }])
            // });

            // //Buttons Group By Category and Supplier
            // buttons.push({
            //     title: 'หมวดสินค้า & ผู้จำหน่าย',
            //     cssClass: 'expand-all-button',
            //     onClick: () => this.view.setGrouping(
            //         [{
            //             formatter: x => 'หมวดสินค้า: ' + x.value + ' (' + x.count + ' items)',
            //             getter: 'CatName'
            //         }, {

            //             formatter: x => 'ผู้จำหน่าย: ' + x.value + ' (' + x.count + ' items)',
            //             getter: 'SupplName'
            //         }])
            // });

            // //Buttons No Grouping
            // buttons.push({
            //     title: 'No Grouping',
            //     cssClass: 'collapse-all-button',
            //     onClick: () => this.view.setGrouping([])
            // });

            return buttons;

        }
        private showOnlyPriceColumn(selectedColumn: string) {
            var columns = this.getColumns();
            var chk = selectedColumn.substring(0, selectedColumn.length - 1);
            let columns2 = columns.filter(c => !c.field.startsWith(chk) || c.field === selectedColumn)
        }

    }
}